export const formatAmount = (amount: number): string => (amount || 0)?.toLocaleString?.('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });